import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import "./GoalsMorePage.css";


export default function GoalsMorePage() {


  const navigate = useNavigate();

  const [goals, setGoals] = useState([]);

 useEffect(() => {

  const goals = JSON.parse(localStorage.getItem("selected_goals"));
  if (!goals) return;

 fetch(`${process.env.REACT_APP_BACKEND_URL}/api/mind-mapping/usecases-by-goals-next`, {
  method:"POST",
  headers:{
    "Content-Type":"application/json"
  },
  body:JSON.stringify({goals})
})

    .then(res=>res.json())
    .then(data=>{

      let fullList = Array.isArray(data) ? data : [];

      if(fullList.length > 5){
        setGoals(data);

      }else{
        setGoals([]);
      }

    })
    .catch(err=>console.error(err));

},[]);

const groupedGoals = goals.reduce((acc, item) => {

  if (!acc[item.goal_name]) {
    acc[item.goal_name] = [];
  }

  acc[item.goal_name].push(item.usecase);

  return acc;

}, {});


 return (
  <div className="goals-page">

  <div className="goals-header">

    <button
      className="goals-back-btn"
      onClick={() => navigate(`/mind-mapping/sec-b`)}
    >
      <FaArrowLeft />
    </button>

    <h1 className="goals-title">Goal Based Opportunities</h1>

</div>


    {goals.length === 0 && (
      <p className="goals-empty">
        No additional goal opportunities available.
      </p>
    )}

  {Object.entries(groupedGoals).map(([goalName, usecases]) => (

  <div key={goalName} className="goal-block">

      <h2 className="goal-heading">
        {goalName}
      </h2>

      <ul className="goals-list">
        {usecases.map((u, i) => (
          <li key={i} className="goals-item">
            {u}
          </li>
        ))}
      </ul>

  </div>

))}



  </div>
);
}
